import { useState } from 'react';
import { Box, Button, HStack, Text } from '@chakra-ui/react';
import { Heart } from 'lucide-react';
import { useSiteConfig } from '../../lib/siteConfig';
import { isAppleMobile, isInstalledApp } from '../../lib/pwa';
import {
  markThanksSeen,
  monthOnly,
  showThanks,
  thanksSeenMonth,
  thanksText,
} from '../../lib/thanksCard';
import { useLanguage, useT } from '../../i18n';

// Once a month on each device, after the install card: what families chipped
// in and what Twinden cost (M55, D197). In the installed app on an iPhone or
// iPad there's no Chip in link (App Store rules), only a line pointing to
// Safari.
export function ThanksCard() {
  const config = useSiteConfig();
  const [seenMonth, setSeenMonth] = useState(thanksSeenMonth);
  const t = useT();
  const locale = useLanguage() === 'hi' ? 'hi-IN' : 'en-IN';
  const costs = config?.costs;
  const supportUrl = config?.supportUrl ?? null;
  if (!costs || !showThanks({ costs, supportUrl, seenMonth })) return null;

  const done = () => {
    markThanksSeen(costs.month);
    setSeenMonth(costs.month);
  };
  const appleInstalled = isInstalledApp() && isAppleMobile();
  const { key, vars } = thanksText(costs, monthOnly(costs.month, locale));

  return (
    <Box px={4} pb={3}>
      <HStack
        align="flex-start"
        spacing={3}
        px={4}
        py={3}
        borderRadius="18px"
        bg="accent.tint"
        role="region"
        aria-label={t('chat.thanks.label')}
      >
        <Box color="accent" pt="2px">
          <Heart size={18} aria-hidden="true" />
        </Box>
        <Box flex="1" minW={0}>
          <Text fontSize="15px" fontWeight={600} lineHeight="20px">
            {t(key, vars)}
          </Text>
          {supportUrl && appleInstalled && (
            <Text fontSize="14px" color="ink.body" mt={1}>
              {t('chat.thanks.safari')}
            </Text>
          )}
          <HStack spacing={2} mt={2}>
            {supportUrl && !appleInstalled && (
              <Button
                as="a"
                href={supportUrl}
                target="_blank"
                rel="noopener noreferrer"
                size="sm"
                onClick={done}
              >
                {t('chat.thanks.chipIn')}
              </Button>
            )}
            <Button size="sm" variant="ghost" color="accent" onClick={done}>
              {t('chat.thanks.ok')}
            </Button>
          </HStack>
        </Box>
      </HStack>
    </Box>
  );
}
